import {
  buildWispClient,
  GetPostsResult,
  GetPostResult,
} from "@wisp-cms/client";

export const wisp = buildWispClient({
  blogId: "996f9bc1-f632-4180-b9a7-e908ba8cc00f",
});

export type { GetPostsResult, GetPostResult };
